// extracted by mini-css-extract-plugin
module.exports = {"recommendTagsList":"GigAssRecommendTags_recommendTagsList__Q3_iR","visible":"GigAssRecommendTags_visible__9azxA","recommendTagItem":"GigAssRecommendTags_recommendTagItem__XcbKi"};